import { type FooterProps, Footer } from '@cms/ui';
import { useRouter } from 'next/router';
import { memo } from 'react';
import { LocaleContext, getLocaleForContext } from '@icommerce/i18n';

import '@cms/ui/src/styling/igus-icons.css';
import '@cms/ui/src/styling/theme.css';
import '@cms/ui/src/styling/header-cms-ui.css';
import '@cms/ui/dist/index.css';

export const StoryblokFooter = memo(({ footer }: { footer: Partial<FooterProps> }) => {
  const { locale } = useRouter();
  const storyblokLocale = getLocaleForContext(locale, LocaleContext.Storyblok);

  return (
    <Footer
      container_1={footer.container_1}
      container_2={footer.container_2}
      container_3={footer.container_3}
      locale={storyblokLocale}
      feedback_text={footer.feedback_text}
      feedback_link={footer.feedback_link}
      linklist={footer.linklist}
      legal={footer.legal}
      cookieSettingLabel={footer.cookieSettingLabel}
      footerLanguage={footer.footerLanguage}
      footerCountry={footer.footerCountry}
    />
  );
});
